import { render, staticRenderFns } from "./CortesiaComponent.vue?vue&type=template&id=6a4e25ec"
import script from "./CortesiaComponent.vue?vue&type=script&lang=js"
export * from "./CortesiaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports